import { render } from "./IntroSection.vue?vue&type=template&id=0faf6b6f&scoped=true"
import script from "./IntroSection.vue?vue&type=script&lang=js"
export * from "./IntroSection.vue?vue&type=script&lang=js"

import "./IntroSection.vue?vue&type=style&index=0&id=0faf6b6f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0faf6b6f"]])

export default __exports__